import { ContentType } from '@/@types/common'
import type { Notification } from '@/@types/notification'
import WIP from '@/components/WIP'
import { isEqual } from 'lodash-es'
import { type HTMLAttributes, type ReactNode, memo } from 'react'
import BehaviorNotification from './BehaviorNotification'
import CommentNotification from './CommentNotification'
import CuriosityNotification from './CuriosityNotification'
import EndowNotification from './EndowNotification'
import GreetAvatarNotification from './GreetAvatarNotification'
import LikeNotification from './LikeNotification'
import MentionNotification from './MentionNotification'
import ProductPageVotedWithCommentNotification from './ProductPageVotedWithCommentNotification'
import RepostNotification from './RepostNotification'
import SilentMentionNotification from './SilentMentionNotification'
import UserFollowNotification from './UserFollowNotification'
import UserRespectNotification from './UserRespectNotification'

export interface CompositeNotificationProps extends HTMLAttributes<HTMLDivElement> {
	data: Notification
}

export default memo(function CompositeNotification({ data, ...props }: CompositeNotificationProps) {
	let content: ReactNode

	switch (data.type) {
		case 'AVATAR_GREET':
			content = <GreetAvatarNotification data={data} />
			break
		case 'USER_SILENT_FOLLOWED':
		case 'USER_FOLLOWED':
			content = <UserFollowNotification data={data} />
			break
		case 'CURIOSITY_ANSWER_REACTION':
		case 'CURIOSITY_MENTION_ME_ANSWER':
		case 'CURIOSITY_REPLIED_MY_MENTIONING':
			content = <CuriosityNotification data={data} />
			break
		case 'PRODUCT_PAGE_VOTED':
			content = <BehaviorNotification data={data} />
			break
		case 'PRODUCT_PAGE_VOTED_WITH_COMMENT':
			content = <ProductPageVotedWithCommentNotification data={data} />
			break
		case 'LIKE_PERSONAL_UPDATE':
			content = <LikeNotification data={data} type={ContentType.POST} />
			break
		case 'LIKE_PERSONAL_UPDATE_COMMENT':
			content = <LikeNotification data={data} type={ContentType.COMMENT} />
			break
		case 'LIKE_STORY':
			content = <LikeNotification data={data} type={ContentType.STORY} />
			break
		case 'REPLIED_TO_PERSONAL_UPDATE_COMMENT':
			content = <CommentNotification data={data} type={ContentType.COMMENT} />
			break
		case 'COMMENT_PERSONAL_UPDATE':
			content = <CommentNotification data={data} type={ContentType.POST} />
			break
		case 'REPLIED_TO_STORY_COMMENT':
			content = <CommentNotification data={data} type={ContentType.COMMENT} noReplyButton />
			break
		case 'COMMENT_STORY':
			content = <CommentNotification data={data} type={ContentType.STORY} noReplyButton />
			break
		case 'COMMENT_AND_REPOST':
			content = <CommentNotification data={data} type={ContentType.POST} />
			break
		case 'PERSONAL_UPDATE_REPOSTED':
			content = <RepostNotification data={data} />
			break
		case 'MENTION_FROM_UNFOLLOWED_USER':
		case 'MENTION':
			content = <MentionNotification data={data} />
			break
		case 'ENDOW':
			content = <EndowNotification data={data} />
			break
		case 'USER_RESPECT':
			content = <UserRespectNotification data={data} />
			break
		case 'SILENT_MENTION':
			content = <SilentMentionNotification data={data} />
			break
	}

	return <>{content ?? <WIP>暂不支持的通知类型</WIP>}</>
}, isEqual)
